import React from 'react';
import Card, { CardIcon, CardTitle, CardText } from '../../card/Card';

export interface FeaturesItemProps {
	title: string;
	text?: string;
	href?: string;
	iconSrc: string;
}

const FeaturesItem: React.FC<FeaturesItemProps> = ({ title, text, href, iconSrc }) => {
	return (
		<Card link={href}>
			<CardIcon src={iconSrc} alt={title} />
			<CardTitle>{title}</CardTitle>
			{text && <CardText>{text}</CardText>}
		</Card>
	);
};

export default FeaturesItem;
